module.exports = __webpack_public_path__ + "img/pencil.c4b2e4b8.png";